import { Vector2 } from "three";

export const getEventPixeslOnElement = (
  event: MouseEvent | TouchEvent | DragEvent | Touch
) => {
  try {
    if (event instanceof TouchEvent) {
      event = event.touches[0];
    }
  } catch {}

  const clientX = (event as any).clientX
    ? (event as any).clientX
    : (event as any).detail.clientX;
  const clientY = (event as any).clientY
    ? (event as any).clientY
    : (event as any).detail.clientY;
  return new Vector2(clientX, clientY);
};
